<template>
    <app-data-table
        :fields="fields"
        :items="data.data || []"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="name" slot-scope="{ item }">
            {{ item.name }}
        </template>

        <template slot="value" slot-scope="{ item }">
            {{ item.value }}
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button variant="primary" size="sm" v-if="userCan('update-items-config')" @click="onEdit(item)">
                <i class="fa fa-edit" aria-hidden="true"></i>
            </b-button>
        </template>
    </app-data-table>
</template>
<script>
import { mixin } from '../../../../mixin';

export default {
    mixins: [mixin],
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: 'Nombre',
                    sortable: true
                },
                {
                    key: 'value',
                    label: 'Valor',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Descripción',
                    sortable: false
                },
                {
                    key: 'actions',
                    label: 'Acciones'
                }
            ]
        };
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        onEdit: {
            type: Function,
            required: true
        },
        onChangePage: {
            type: Function,
            required: true
        }
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx);
        }
    }
};
</script>

